<main class="bg-[#9ACDFF]"><router-view :key="$route.fullPath"></router-view></main>